import { NgModule } from '@angular/core';
import { DropdownModule } from '@tcp/dropdown';
import { ConvertModuleToMethodPipe } from './convert-module-to-method.pipe';

@NgModule({
  imports: [DropdownModule],
  exports: [ConvertModuleToMethodPipe, DropdownModule],
  declarations: [ConvertModuleToMethodPipe],
  providers: [],
})
export class DropdownEssentialsModule { }
